import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as tracPage from '@webapp/sdk/tracpage';
import AppState from '../../state';
import { hasPlanFeature } from '../../../sdk/plans';
import { PlanNames } from '../../../../../../services/product/types/plan-names';

export const createTracLinkEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, actionCreators.CreateTracLink>(actions.CREATE_TRAC_LINK),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    mergeMap(async ([action, state]) => {
      try {
        const tracLink = await tracPage.createTracLink(
          state.artist.active?.id as string,
          {
            ...action.tracLink,
            removeBranding: hasPlanFeature(
              (state.subscription.current?.plan.toLowerCase() as PlanNames) ||
                'beginner',
              'RELEASE.REMOVE_BRANDING'
            ),
          }
        );

        return new actionCreators.CreateTracLinkSuccess(tracLink);
      } catch (err) {
        return new actionCreators.CreateTracLinkError(err.message);
      }
    })
  );
